import styled from "styled-components";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

export const ContentWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  z-index: 3;
`;

export const BackgroundVideoWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const SlideHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 24px 0;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin: 16px 0;
  }
`;

export const SlideTitle = styled.h3`
  color: #212427;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  text-wrap: pretty;
  margin: 0;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 20px;
    text-wrap: pretty;
    text-align: center;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 18px;
    line-height: normal;
  }
`;

export const StyledDescription = styled.p`
  margin: 0;
  color: #808893;
  font-size: 16px;
  line-height: 24px;
  max-width: 620px;
  text-wrap: pretty;
  text-align: center;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 14px;
    line-height: 20px;
  }

  a,
  button {
    color: ${({ theme }) => theme.colors.primaryBlue};
    outline: none;
    border: none;
    background: transparent;
  }
`;

export const DisplayContainer = styled.div`
  display: flex;
  justify-content: center;
  max-height: 928px;
  max-width: 100vw;
  width: 100%;
`;

export const DisplayBackground = styled.div`
  aspect-ratio: 1388/928;
  max-height: 928px;
  max-width: 1388px;
  position: relative;
  width: 100%;
`;

export const StyledDisplay = styled.img`
  aspect-ratio: 1388 / 928;
  height: 100%;
  object-fit: unset;
  position: absolute;
  max-width: 100%;
  z-index: 5;
  overflow: hidden;
`;

export const StyledVideo = styled.video<{ $scale: number }>`
  aspect-ratio: 1353 / 762;
  height: auto;
  max-width: 100%;
  object-fit: unset;
  z-index: 7;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  margin: ${({ $scale }) => `${$scale * 20}px ${$scale * 18}px 0`};
  width: calc(100% - ${({ $scale }) => $scale * 36}px);
`;

export const IphoneWatchWrapper = styled.div<{ $scale: number }>`
  align-items: flex-end;
  bottom: 5%;
  direction: ltr;
  display: flex;
  max-height: 564px;
  max-width: 274px;
  overflow: hidden;
  position: absolute;
  right: -2%;
  transform-origin: bottom right;
  transform: scale(${({ $scale }) => $scale});
  z-index: 8;
`;

export const StyledIphoneBezel = styled.img`
  aspect-ratio: 274 / 564;
  height: 100%;
  object-fit: unset;
  position: absolute;
  max-width: 100%;
  z-index: 5;
  overflow: hidden;
`;

export const Iphone = styled.video`
  aspect-ratio: 274 / 564;
  border-radius: 45px;
  height: 100%;
  object-fit: contain;
  background-color: ${({ theme }) => theme.colors.white};
  margin: 9px 0px 12px 6px;
  width: calc(100% - 10px);
`;
